<template>
  <material-card class="pt-2" full-header>
    <template #heading>
      <v-toolbar color="accent">
        <v-toolbar-title>
          <v-icon> mdi-google-classroom </v-icon>
          {{ $t("bigbluebutton_raw_files", { domain: serverData.domain }) }}
        </v-toolbar-title>

        <v-spacer />
        <v-btn text icon dark class="mb-2" @click="close">
          <v-icon medium>mdi-close-circle-outline</v-icon>
        </v-btn>
      </v-toolbar>
    </template>

    <v-data-table :items="rawFileList" :headers="rawFilesHeader" :loading="loading" item-key="meeting_id"
      :search="search" show-select v-model="selectedRows" show-expand single-expand :expanded.sync="expanded" :footer-props="{ showFirstLastPage: true}">
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <BBBPublishedFiles :key="item.externalId" :serverData="serverData" :meetingId="item?.externalId">
          </BBBPublishedFiles>
        </td>
      </template>

      <template v-slot:top>
        <v-toolbar>
          <v-toolbar-title>
            <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('search')" single-line
              hide-details></v-text-field>
          </v-toolbar-title>
          <v-divider vertical></v-divider>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text icon dark class="mb-2" v-bind="attrs" v-on="on" color="primary" @click="getRawFiles">
                <v-icon medium>mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>
              {{ $t("refresh") }}
            </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text icon dark class="mb-2" v-bind="attrs" v-on="on" color="primary" @click="updateRawFiles"
              v-show="hasPermission('command_bigbluebutton_update_raw_list')">
                <v-icon medium>mdi-update</v-icon>
              </v-btn>
            </template>
            <span>
              {{ $t("bbb_update_raw_files_list") }}
            </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text icon dark class="mb-2" v-bind="attrs" v-on="on" color="primary" @click="showRebuildDialog"
              v-show="hasPermission('command_bigbluebutton_rebuild')">
                <v-icon medium>mdi-office-building</v-icon>
              </v-btn>
            </template>
            <span>
              {{ $t("bbb_raw_files_rebuild") }}
            </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text icon dark class="mb-2" v-bind="attrs" v-on="on" color="primary" @click="showDeleteDialog"
              v-show="hasPermission('command_bigbluebutton_removeraw')">
                <v-icon medium>mdi-trash-can-outline</v-icon>
              </v-btn>
            </template>
            <span>
              {{ $t("bbb_raw_files_delete") }}
            </span>
          </v-tooltip>
        </v-toolbar>
      </template>
      <!-- custom columns -->
      <template v-slot:[`item.rebuild`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="ma-2" text icon v-bind="attrs" v-on="on" :disabled="!hasPermission('command_bigbluebutton_rebuild')">
              <v-icon color="primary" medium @click="rebuildItem(item)">mdi-office-building</v-icon>
            </v-btn>

          </template>
          <span>{{ $t("bbb_raw_files_rebuild") }}</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.start_recording`]="{ item }">
        <span>{{ $t(item.start_recording.toString()) }}</span>
      </template>
      <template v-slot:[`item.recording_stop_at`]="{ item }">
        <span>{{ $t(item.recording_stop_at.toString()) }}</span>
      </template>
    </v-data-table>
    <template #actions>

    </template>
    <AskDialog :visible="rebuildDialog" yes no :loading="rebuildLoading" @yesClick="rebuildRawFiles"
      @noClick="closeRebuildDialog" :text="rebuildDialogText"></AskDialog>
    <AskDialog :visible="deleteDialog" yes no :loading="deleteLoading" @yesClick="deleteRawFiles"
      @noClick="closeDeleteDialog" :text="deleteDialogText"></AskDialog>
  </material-card>
</template>
<script>
import permissions from '../mixins/permissions';

export default {
  name: "BBBRawFiles",
  mixins:[permissions],
  props: {
    visible: Boolean,
    serverData: {
      type: Object,
      default: {}
    }
  },
  computed: {

  },
  data() {
    return {

      rawFilesHeader: [
        { value: "meetingName", text: this.$t("meeting_name") },
        { value: "bbb-origin-server-name", text: this.$t("running") },
        { value: "start_recording", text: this.$t("recording_start_at") },
        { value: "recording_stop_at", text: this.$t("recording_stop_at") },
        { value: "meeting_id", text: this.$t("meeting_id") },
        { value: "jalalidate", text: this.$t("created_at") },
        { value: "rebuild", text: this.$t("Rebuild") },
      ],
      rawFileList: [],
      loading: true,
      totalServers: 0,
      options: {},
      itemPerPage: 10,
      pageNumber: 1,
      startRow: 0,
      endRow: 10,
      joinLoading: false,
      search: '',
      expanded: [],
      selectedRows: [],
      rebuildDialog: false,
      rebuildLoading: false,
      rebuildDialogText: '',
      deleteDialog: false,
      deleteLoading: false,
      deleteDialogText: ''
    };
  },
  watch: {
    options: {
      handler() {
        this.getRawFiles();
      },
      deep: true,
    },
  },
  methods: {
    getRawFiles() {
      this.loading = true;
      axios({
        url: process.env.VUE_APP_BACKEND_URL + "/api/command/bigbluebutton/raw/" + this.serverData.id,
        method: "GET",
        headers: {
          Authorization: this.$store.get("login/token"),
        },
      })
        .then((response) => {
          let data = response.data.message;
          if (data == undefined) return;
          this.rawFileList = (Array.isArray(data) ? data : [{ ...data }]);
          this.loading = false;
        })
        .catch((error) => {
          console.log('error', error);
        }).finally(() => {
          this.loading = false;
        });
    },
    updateRawFiles() {
      this.loading = true;
      axios({
        url: process.env.VUE_APP_BACKEND_URL + "/api/command/bigbluebutton/raw/" + this.serverData.id,
        method: "PUT",
        headers: {
          Authorization: this.$store.get("login/token"),
        },
      })
        .then((response) => {
          this.$toasted.success(this.$t('bbb_raw_files_updated_successfully'))
        })
        .catch((error) => {
          console.log('error', error);
        }).finally(() => {
          this.loading = false;
        });
    },
    rebuildRawFiles() {
      this.rebuildLoading = true;
      let recordIds = [];
      this.selectedRows.forEach(record => {
        recordIds.push({ recordId: record.meeting_id });
      })

      axios({
        url: process.env.VUE_APP_BACKEND_URL + "/api/command/bigbluebutton/rebuild/" + this.serverData.id,
        method: "POST",
        headers: {
          Authorization: this.$store.get("login/token"),
        },
        data: { recordIds }
      })
        .then((response) => {
          this.$toasted.success(this.$t('bbb_raw_files_rebuild_successfully'))
        })
        .catch((error) => {
          console.log('error', error);
        }).finally(() => {
          this.rebuildLoading = false;
        });
    },
    rebuildItem(item) {
      this.selectedRows = [item]
      this.showRebuildDialog();
    },
    deleteRawFiles() {
      this.deleteLoading = true;
      axios({
        url: process.env.VUE_APP_BACKEND_URL + "/api/command/bigbluebutton/removeraw/" + this.serverData.id,
        method: "POST",
        headers: {
          Authorization: this.$store.get("login/token"),
        },
      })
        .then((response) => {
          this.$toasted.success(this.$t('bbb_raw_files_delete_successfully'))
        })
        .catch((error) => {
          console.log('error', error);
        }).finally(() => {
          this.deleteLoading = false;
        });
    },
    showRebuildDialog() {
      if (this.selectedRows.length == 0) {
        this.$toasted.error(this.$t('select_a_row'))
        return;
      }
      this.rebuildDialogText = this.$t('rebuild_dialog_text');
      this.rebuildDialog = true;
    },
    closeRebuildDialog() {
      this.rebuildDialogText = '';
      this.rebuildDialog = false;
    },
    showDeleteDialog() {
      this.deleteDialogText = this.$t('bbb_raw_files_delete_dialog_text');
      this.deleteDialog = true;
    },
    closeDeleteDialog() {
      this.deleteDialogText = '';
      this.deleteDialog = false;
    },
    close() {
      this.$emit('close')
    }

  },
  mounted() {
    this.getRawFiles();
  },
};
</script>
<style>
.text-content-left input {
  text-align: left !important;
}
</style>
  